// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ══════════════════════════════════════════════
   ModalHistoric — Premium Design
   ══════════════════════════════════════════════ */

/* ── Main Container ── */
.mh-container {
    display: flex;
    width: 100%;
    height: 100%;
    overflow: hidden;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

/* ── LEFT PANEL ── */
.mh-left-panel {
    width: 35%;
    min-width: 250px;
    border-right: 1px solid #e2e8f0;
    background: #f8fafc;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.mh-metrics-header {
    padding: 12px 16px;
    border-bottom: 1px solid #e2e8f0;
    background: rgba(248, 250, 252, 0.95);
    position: sticky;
    top: 0;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 48px;
}

/* ── Search Toggle Button ── */
.mh-search-toggle {
    border: none;
    background: transparent;
    padding: 4px 6px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    color: #94a3b8;
    transition: all 0.15s;
}

.mh-search-toggle:hover {
    color: #0B2A5B;
    background: #e2e8f0;
}

/* ── Search Input ── */
.mh-search-input-wrap {
    display: flex;
    align-items: center;
    width: 100%;
    position: relative;
}

.mh-search-icon {
    position: absolute;
    left: 10px;
    font-size: 12px;
    color: #94a3b8;
    pointer-events: none;
}

.mh-search-input {
    width: 100%;
    padding: 6px 30px 6px 30px;
    background: #fff;
    border: 1px solid #cbd5e1;
    border-radius: 8px;
    font-size: 13px;
    color: #1e293b;
    outline: none;
    transition: all 0.15s;
}

.mh-search-input:focus {
    border-color: #0B2A5B;
    box-shadow: 0 0 0 3px rgba(11, 42, 91, 0.08);
}

.mh-search-input::placeholder {
    color: #94a3b8;
}

.mh-search-clear {
    position: absolute;
    right: 6px;
    border: none;
    background: transparent;
    padding: 2px 4px;
    border-radius: 50%;
    cursor: pointer;
    font-size: 11px;
    color: #94a3b8;
    transition: all 0.15s;
}

.mh-search-clear:hover {
    color: #475569;
    background: #f1f5f9;
}

/* ── Search empty state ── */
.mh-search-empty {
    padding: 32px 16px;
    text-align: center;
    font-size: 13px;
    color: #64748b;
}

.mh-metrics-title {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #64748b;
}

.mh-metrics-list {
    flex: 1 1;
    overflow-y: auto;
    padding: 8px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    scrollbar-width: thin;
}

/* ── Metric Card ── */
.mh-metric-card {
    width: 100%;
    text-align: left;
    padding: 10px 14px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid transparent;
    background: transparent;
    cursor: pointer;
    transition: all 0.2s ease;
    gap: 8px;
}

.mh-metric-card:hover {
    background: #f1f5f9;
    border-color: #e2e8f0;
}

.mh-metric-selected {
    background: rgba(11, 42, 91, 0.04) !important;
    border-color: rgba(11, 42, 91, 0.15) !important;
    box-shadow: 0 1px 4px rgba(11, 42, 91, 0.08);
}

.mh-metric-info {
    display: flex;
    flex-direction: column;
    gap: 3px;
    min-width: 0;
}

.mh-metric-name {
    font-size: 13px;
    font-weight: 500;
    color: #334155;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.mh-metric-name-active {
    color: #0B2A5B;
    font-weight: 600;
}

.mh-metric-lastupdate {
    font-size: 10px;
    color: #94a3b8;
    display: flex;
    align-items: center;
    gap: 3px;
}

.mh-metric-lastupdate-active {
    color: rgba(11, 42, 91, 0.55);
}

.mh-metric-value-area {
    display: flex;
    align-items: center;
    flex-shrink: 0;
}

.mh-metric-numeric {
    display: flex;
    align-items: baseline;
    gap: 3px;
}

.mh-metric-val {
    font-size: 16px;
    font-weight: 700;
    color: #0f172a;
}

.mh-metric-val-active {
    color: #0B2A5B;
}

.mh-metric-unit {
    font-size: 11px;
    color: #64748b;
}

.mh-metric-unit-active {
    color: rgba(11, 42, 91, 0.6);
}

/* ── Status Badges ── */
.mh-status-badge {
    display: inline-block;
    padding: 4px 10px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 600;
    border: 1px solid;
    white-space: nowrap;
}

.mh-status-success {
    background: #ecfdf5;
    color: #059669;
    border-color: #a7f3d0;
}

.mh-status-error {
    background: #fff1f2;
    color: #e11d48;
    border-color: #fecdd3;
}

/* ── RIGHT PANEL ── */
.mh-right-panel {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    background: #fff;
    /* padding: 16px 20px; */
    overflow: hidden;
    min-width: 0;
    height: 100%;
}

/* ── Empty state — Premium Animated ── */
.mh-empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    gap: 0;
    position: relative;
    overflow: hidden;
    background: radial-gradient(ellipse at center, rgba(11, 42, 91, 0.03) 0%, transparent 70%);
}

/* ── Floating Particles ── */
.mh-empty-particles {
    position: absolute;
    inset: 0;
    pointer-events: none;
}

.mh-particle {
    position: absolute;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #0B2A5B;
    opacity: 0;
    animation: mh-float 6s ease-in-out infinite;
}

.mh-particle.p1 {
    left: 15%;
    top: 25%;
    animation-delay: 0s;
    width: 4px;
    height: 4px;
}

.mh-particle.p2 {
    left: 75%;
    top: 15%;
    animation-delay: 1.2s;
    width: 5px;
    height: 5px;
}

.mh-particle.p3 {
    left: 85%;
    top: 60%;
    animation-delay: 2.4s;
    width: 3px;
    height: 3px;
}

.mh-particle.p4 {
    left: 25%;
    top: 70%;
    animation-delay: 3.6s;
    width: 4px;
    height: 4px;
}

.mh-particle.p5 {
    left: 55%;
    top: 80%;
    animation-delay: 4.8s;
    width: 6px;
    height: 6px;
}

@keyframes mh-float {

    0%,
    100% {
        opacity: 0;
        transform: translateY(0) scale(0.5);
    }

    20% {
        opacity: 0.15;
    }

    50% {
        opacity: 0.25;
        transform: translateY(-20px) scale(1);
    }

    80% {
        opacity: 0.1;
    }
}

/* ── SVG Illustration ── */
.mh-empty-illustration {
    width: 220px;
    margin-bottom: 20px;
    animation: mh-fadeInUp 0.8s ease-out both;
}

.mh-empty-svg {
    width: 100%;
    filter: drop-shadow(0 4px 12px rgba(11, 42, 91, 0.08));
}

/* Line drawing animation */
.mh-empty-line {
    stroke-dasharray: 400;
    stroke-dashoffset: 400;
    animation: mh-drawLine 2s ease-out 0.5s forwards;
}

@keyframes mh-drawLine {
    to {
        stroke-dashoffset: 0;
    }
}

/* Area fade in */
.mh-empty-area {
    opacity: 0;
    animation: mh-fadeIn 0.8s ease-out 2s forwards;
}

/* Data dots pop in */
.mh-empty-dot {
    opacity: 0;
    transform-origin: center;
    animation: mh-popDot 0.4s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
}

.mh-empty-dot.d1 {
    animation-delay: 1.2s;
}

.mh-empty-dot.d2 {
    animation-delay: 1.6s;
}

.mh-empty-dot.d3 {
    animation-delay: 2s;
}

@keyframes mh-popDot {
    0% {
        opacity: 0;
        r: 0;
    }

    100% {
        opacity: 1;
        r: 4;
    }
}

/* Pulse ring on last dot */
.mh-empty-pulse-ring {
    animation: mh-pulseRing 2s ease-out 2.4s infinite;
}

@keyframes mh-pulseRing {
    0% {
        opacity: 0.6;
        r: 4;
    }

    100% {
        opacity: 0;
        r: 16;
    }
}

/* ── CTA Content ── */
.mh-empty-cta {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    animation: mh-fadeInUp 0.8s ease-out 0.3s both;
}

.mh-empty-title {
    font-size: 20px;
    font-weight: 700;
    color: #1e293b;
    margin: 0 0 8px 0;
    letter-spacing: -0.02em;
}

.mh-empty-subtitle {
    font-size: 13px;
    color: #64748b;
    line-height: 1.6;
    max-width: 320px;
    margin: 0 0 18px 0;
}

.mh-empty-arrow {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: linear-gradient(135deg, #0B2A5B 0%, #1e40af 100%);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 14px rgba(11, 42, 91, 0.3);
    animation: mh-bounceLeft 2s ease-in-out 1s infinite;
}

@keyframes mh-bounceLeft {

    0%,
    100% {
        transform: translateX(0);
    }

    50% {
        transform: translateX(-8px);
    }
}

@keyframes mh-fadeInUp {
    from {
        opacity: 0;
        transform: translateY(16px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes mh-fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

/* ── Chart Header ── */
.mh-chart-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
    gap: 12px;
    flex-wrap: wrap;
    flex-shrink: 0;
}

.mh-chart-title {
    font-size: 16px;
    font-weight: 700;
    color: var(--third-color);
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    position: relative;
    left: 5%;

}

.mh-chart-controls {
    display: flex;
    align-items: center;
    gap: 8px;
    background: #f8fafc;
    padding: 4px 6px;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
    flex-shrink: 0;
    position: relative;
    right: 5%;
}

/* ── Y-Axis Toggle ── */
.mh-yaxis-toggle {
    display: flex;
    align-items: center;
    gap: 0;
    background: #fff;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    padding: 2px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.mh-toggle-label {
    font-size: 11px;
    font-weight: 600;
    color: #64748b;
    padding: 0 8px;
    white-space: nowrap;
}

.mh-toggle-btn {
    padding: 4px 10px;
    border-radius: 6px;
    border: none;
    background: transparent;
    font-size: 11px;
    font-weight: 600;
    color: #64748b;
    cursor: pointer;
    transition: all 0.15s ease;
    white-space: nowrap;
}

.mh-toggle-btn:hover {
    background: #f1f5f9;
}

.mh-toggle-active {
    background: #f1f5f9 !important;
    color: #0f172a !important;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
}

.mh-divider {
    width: 1px;
    height: 20px;
    background: #cbd5e1;
    flex-shrink: 0;
}

/* ── Time Badge ── */
.mh-time-badge {
    padding: 4px 10px;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 600;
    color: #475569;
    white-space: nowrap;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

/* ── Refresh / Reset Button ── */
.mh-refresh-btn {
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    color: #64748b;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.15s ease;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.mh-refresh-btn:hover {
    color: #0B2A5B;
    background: rgba(11, 42, 91, 0.06);
    border-color: rgba(11, 42, 91, 0.2);
}

/* ── Chart Area ── */
.mh-chart-area {
    flex: 1 1;
    min-height: 0;
    position: relative;
    border: 1px solid #f1f5f9;
    border-radius: 14px;
    background: rgba(248, 250, 252, 0.4);
    padding: 12px;
    overflow: hidden;
}

.mh-chart-area canvas {
    width: 100% !important;
    height: 100% !important;
}

/* ── Chart Hint ── */
.mh-chart-hint {
    position: absolute;
    top: 8px;
    right: 10px;
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 10px;
    color: #94a3b8;
    background: rgba(255, 255, 255, 0.85);
    padding: 3px 8px;
    border-radius: 6px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    z-index: 10;
    pointer-events: none;
    -webkit-backdrop-filter: blur(4px);
            backdrop-filter: blur(4px);
}

/* ── Loading & No Results ── */
.mh-loading {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.mh-no-results {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #94a3b8;
    font-size: 14px;
}

/* ── Keep old classes for compatibility ── */
.cont-graphic-historic {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/components/monitor-components/styles/modalHistoric.css"],"names":[],"mappings":"AAAA;;mDAEmD;;AAEnD,yBAAyB;AACzB;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,8EAA8E;AAClF;;AAEA,qBAAqB;AACrB;IACI,UAAU;IACV,gBAAgB;IAChB,+BAA+B;IAC/B,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,qCAAqC;IACrC,gBAAgB;IAChB,MAAM;IACN,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA,+BAA+B;AAC/B;IACI,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,0BAA0B;IAC1B,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA,6BAA6B;AAC7B;IACI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,qBAAqB;AACzB;;AAEA,sBAAsB;AACtB;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,6BAA6B;IAC7B,uBAAuB;IACvB,eAAe;IACf,yBAAyB;IACzB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,6CAA6C;IAC7C,+CAA+C;IAC/C,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,4BAA4B;AAChC;;AAEA,wBAAwB;AACxB;IACI,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA,sBAAsB;AACtB;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,wBAAwB;IACxB,gBAAgB;IAChB,YAAY;IACZ,YAAY;AAChB;;AAEA,yCAAyC;AACzC;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,MAAM;IACN,kBAAkB;IAClB,gBAAgB;IAChB,0FAA0F;AAC9F;;AAEA,6BAA6B;AAC7B;IACI,kBAAkB;IAClB,QAAQ;IACR,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;IACV,2CAA2C;AAC/C;;AAEA;IACI,SAAS;IACT,QAAQ;IACR,mBAAmB;IACnB,UAAU;IACV,WAAW;AACf;;AAEA;IACI,SAAS;IACT,QAAQ;IACR,qBAAqB;IACrB,UAAU;IACV,WAAW;AACf;;AAEA;IACI,SAAS;IACT,QAAQ;IACR,qBAAqB;IACrB,UAAU;IACV,WAAW;AACf;;AAEA;IACI,SAAS;IACT,QAAQ;IACR,qBAAqB;IACrB,UAAU;IACV,WAAW;AACf;;AAEA;IACI,SAAS;IACT,QAAQ;IACR,qBAAqB;IACrB,UAAU;IACV,WAAW;AACf;;AAEA;;IAEI;;QAEI,UAAU;QACV,mCAAmC;IACvC;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,qCAAqC;IACzC;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA,2BAA2B;AAC3B;IACI,YAAY;IACZ,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,WAAW;IACX,sDAAsD;AAC1D;;AAEA,2BAA2B;AAC3B;IACI,qBAAqB;IACrB,sBAAsB;IACtB,gDAAgD;AACpD;;AAEA;IACI;QACI,oBAAoB;IACxB;AACJ;;AAEA,iBAAiB;AACjB;IACI,UAAU;IACV,8CAA8C;AAClD;;AAEA,qBAAqB;AACrB;IACI,UAAU;IACV,wBAAwB;IACxB,oEAAoE;AACxE;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,UAAU;QACV,IAAI;IACR;;IAEA;QACI,UAAU;QACV,IAAI;IACR;AACJ;;AAEA,2BAA2B;AAC3B;IACI,iDAAiD;AACrD;;AAEA;IACI;QACI,YAAY;QACZ,IAAI;IACR;;IAEA;QACI,UAAU;QACV,KAAK;IACT;AACJ;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,8CAA8C;AAClD;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,6DAA6D;IAC7D,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,4CAA4C;IAC5C,mDAAmD;AACvD;;AAEA;;IAEI;;QAEI,wBAAwB;IAC5B;;IAEA;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,SAAS;IACT,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;IAClB,QAAQ;;AAEZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,SAAS;AACb;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,mBAAmB;IACnB,MAAM;IACN,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,yBAAyB;IACzB,yCAAyC;AAC7C;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,cAAc;AAClB;;AAEA,qBAAqB;AACrB;IACI,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA,iCAAiC;AACjC;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,eAAe;IACf,0BAA0B;IAC1B,yCAAyC;AAC7C;;AAEA;IACI,cAAc;IACd,kCAAkC;IAClC,mCAAmC;AACvC;;AAEA,qBAAqB;AACrB;IACI,SAAO;IACP,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,oCAAoC;IACpC,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA,qBAAqB;AACrB;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,cAAc;IACd,qCAAqC;IACrC,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,yCAAyC;IACzC,WAAW;IACX,oBAAoB;IACpB,kCAA0B;YAA1B,0BAA0B;AAC9B;;AAEA,+BAA+B;AAC/B;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,eAAe;AACnB;;AAEA,6CAA6C;AAC7C;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB","sourcesContent":["/* ══════════════════════════════════════════════\n   ModalHistoric — Premium Design\n   ══════════════════════════════════════════════ */\n\n/* ── Main Container ── */\n.mh-container {\n    display: flex;\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n}\n\n/* ── LEFT PANEL ── */\n.mh-left-panel {\n    width: 35%;\n    min-width: 250px;\n    border-right: 1px solid #e2e8f0;\n    background: #f8fafc;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n}\n\n.mh-metrics-header {\n    padding: 12px 16px;\n    border-bottom: 1px solid #e2e8f0;\n    background: rgba(248, 250, 252, 0.95);\n    position: sticky;\n    top: 0;\n    z-index: 10;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    min-height: 48px;\n}\n\n/* ── Search Toggle Button ── */\n.mh-search-toggle {\n    border: none;\n    background: transparent;\n    padding: 4px 6px;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 14px;\n    color: #94a3b8;\n    transition: all 0.15s;\n}\n\n.mh-search-toggle:hover {\n    color: #0B2A5B;\n    background: #e2e8f0;\n}\n\n/* ── Search Input ── */\n.mh-search-input-wrap {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    position: relative;\n}\n\n.mh-search-icon {\n    position: absolute;\n    left: 10px;\n    font-size: 12px;\n    color: #94a3b8;\n    pointer-events: none;\n}\n\n.mh-search-input {\n    width: 100%;\n    padding: 6px 30px 6px 30px;\n    background: #fff;\n    border: 1px solid #cbd5e1;\n    border-radius: 8px;\n    font-size: 13px;\n    color: #1e293b;\n    outline: none;\n    transition: all 0.15s;\n}\n\n.mh-search-input:focus {\n    border-color: #0B2A5B;\n    box-shadow: 0 0 0 3px rgba(11, 42, 91, 0.08);\n}\n\n.mh-search-input::placeholder {\n    color: #94a3b8;\n}\n\n.mh-search-clear {\n    position: absolute;\n    right: 6px;\n    border: none;\n    background: transparent;\n    padding: 2px 4px;\n    border-radius: 50%;\n    cursor: pointer;\n    font-size: 11px;\n    color: #94a3b8;\n    transition: all 0.15s;\n}\n\n.mh-search-clear:hover {\n    color: #475569;\n    background: #f1f5f9;\n}\n\n/* ── Search empty state ── */\n.mh-search-empty {\n    padding: 32px 16px;\n    text-align: center;\n    font-size: 13px;\n    color: #64748b;\n}\n\n.mh-metrics-title {\n    font-size: 11px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    color: #64748b;\n}\n\n.mh-metrics-list {\n    flex: 1;\n    overflow-y: auto;\n    padding: 8px;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    scrollbar-width: thin;\n}\n\n/* ── Metric Card ── */\n.mh-metric-card {\n    width: 100%;\n    text-align: left;\n    padding: 10px 14px;\n    border-radius: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border: 1px solid transparent;\n    background: transparent;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    gap: 8px;\n}\n\n.mh-metric-card:hover {\n    background: #f1f5f9;\n    border-color: #e2e8f0;\n}\n\n.mh-metric-selected {\n    background: rgba(11, 42, 91, 0.04) !important;\n    border-color: rgba(11, 42, 91, 0.15) !important;\n    box-shadow: 0 1px 4px rgba(11, 42, 91, 0.08);\n}\n\n.mh-metric-info {\n    display: flex;\n    flex-direction: column;\n    gap: 3px;\n    min-width: 0;\n}\n\n.mh-metric-name {\n    font-size: 13px;\n    font-weight: 500;\n    color: #334155;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.mh-metric-name-active {\n    color: #0B2A5B;\n    font-weight: 600;\n}\n\n.mh-metric-lastupdate {\n    font-size: 10px;\n    color: #94a3b8;\n    display: flex;\n    align-items: center;\n    gap: 3px;\n}\n\n.mh-metric-lastupdate-active {\n    color: rgba(11, 42, 91, 0.55);\n}\n\n.mh-metric-value-area {\n    display: flex;\n    align-items: center;\n    flex-shrink: 0;\n}\n\n.mh-metric-numeric {\n    display: flex;\n    align-items: baseline;\n    gap: 3px;\n}\n\n.mh-metric-val {\n    font-size: 16px;\n    font-weight: 700;\n    color: #0f172a;\n}\n\n.mh-metric-val-active {\n    color: #0B2A5B;\n}\n\n.mh-metric-unit {\n    font-size: 11px;\n    color: #64748b;\n}\n\n.mh-metric-unit-active {\n    color: rgba(11, 42, 91, 0.6);\n}\n\n/* ── Status Badges ── */\n.mh-status-badge {\n    display: inline-block;\n    padding: 4px 10px;\n    border-radius: 20px;\n    font-size: 11px;\n    font-weight: 600;\n    border: 1px solid;\n    white-space: nowrap;\n}\n\n.mh-status-success {\n    background: #ecfdf5;\n    color: #059669;\n    border-color: #a7f3d0;\n}\n\n.mh-status-error {\n    background: #fff1f2;\n    color: #e11d48;\n    border-color: #fecdd3;\n}\n\n/* ── RIGHT PANEL ── */\n.mh-right-panel {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    background: #fff;\n    /* padding: 16px 20px; */\n    overflow: hidden;\n    min-width: 0;\n    height: 100%;\n}\n\n/* ── Empty state — Premium Animated ── */\n.mh-empty-state {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    gap: 0;\n    position: relative;\n    overflow: hidden;\n    background: radial-gradient(ellipse at center, rgba(11, 42, 91, 0.03) 0%, transparent 70%);\n}\n\n/* ── Floating Particles ── */\n.mh-empty-particles {\n    position: absolute;\n    inset: 0;\n    pointer-events: none;\n}\n\n.mh-particle {\n    position: absolute;\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background: #0B2A5B;\n    opacity: 0;\n    animation: mh-float 6s ease-in-out infinite;\n}\n\n.mh-particle.p1 {\n    left: 15%;\n    top: 25%;\n    animation-delay: 0s;\n    width: 4px;\n    height: 4px;\n}\n\n.mh-particle.p2 {\n    left: 75%;\n    top: 15%;\n    animation-delay: 1.2s;\n    width: 5px;\n    height: 5px;\n}\n\n.mh-particle.p3 {\n    left: 85%;\n    top: 60%;\n    animation-delay: 2.4s;\n    width: 3px;\n    height: 3px;\n}\n\n.mh-particle.p4 {\n    left: 25%;\n    top: 70%;\n    animation-delay: 3.6s;\n    width: 4px;\n    height: 4px;\n}\n\n.mh-particle.p5 {\n    left: 55%;\n    top: 80%;\n    animation-delay: 4.8s;\n    width: 6px;\n    height: 6px;\n}\n\n@keyframes mh-float {\n\n    0%,\n    100% {\n        opacity: 0;\n        transform: translateY(0) scale(0.5);\n    }\n\n    20% {\n        opacity: 0.15;\n    }\n\n    50% {\n        opacity: 0.25;\n        transform: translateY(-20px) scale(1);\n    }\n\n    80% {\n        opacity: 0.1;\n    }\n}\n\n/* ── SVG Illustration ── */\n.mh-empty-illustration {\n    width: 220px;\n    margin-bottom: 20px;\n    animation: mh-fadeInUp 0.8s ease-out both;\n}\n\n.mh-empty-svg {\n    width: 100%;\n    filter: drop-shadow(0 4px 12px rgba(11, 42, 91, 0.08));\n}\n\n/* Line drawing animation */\n.mh-empty-line {\n    stroke-dasharray: 400;\n    stroke-dashoffset: 400;\n    animation: mh-drawLine 2s ease-out 0.5s forwards;\n}\n\n@keyframes mh-drawLine {\n    to {\n        stroke-dashoffset: 0;\n    }\n}\n\n/* Area fade in */\n.mh-empty-area {\n    opacity: 0;\n    animation: mh-fadeIn 0.8s ease-out 2s forwards;\n}\n\n/* Data dots pop in */\n.mh-empty-dot {\n    opacity: 0;\n    transform-origin: center;\n    animation: mh-popDot 0.4s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;\n}\n\n.mh-empty-dot.d1 {\n    animation-delay: 1.2s;\n}\n\n.mh-empty-dot.d2 {\n    animation-delay: 1.6s;\n}\n\n.mh-empty-dot.d3 {\n    animation-delay: 2s;\n}\n\n@keyframes mh-popDot {\n    0% {\n        opacity: 0;\n        r: 0;\n    }\n\n    100% {\n        opacity: 1;\n        r: 4;\n    }\n}\n\n/* Pulse ring on last dot */\n.mh-empty-pulse-ring {\n    animation: mh-pulseRing 2s ease-out 2.4s infinite;\n}\n\n@keyframes mh-pulseRing {\n    0% {\n        opacity: 0.6;\n        r: 4;\n    }\n\n    100% {\n        opacity: 0;\n        r: 16;\n    }\n}\n\n/* ── CTA Content ── */\n.mh-empty-cta {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    animation: mh-fadeInUp 0.8s ease-out 0.3s both;\n}\n\n.mh-empty-title {\n    font-size: 20px;\n    font-weight: 700;\n    color: #1e293b;\n    margin: 0 0 8px 0;\n    letter-spacing: -0.02em;\n}\n\n.mh-empty-subtitle {\n    font-size: 13px;\n    color: #64748b;\n    line-height: 1.6;\n    max-width: 320px;\n    margin: 0 0 18px 0;\n}\n\n.mh-empty-arrow {\n    width: 44px;\n    height: 44px;\n    border-radius: 50%;\n    background: linear-gradient(135deg, #0B2A5B 0%, #1e40af 100%);\n    color: #fff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0 4px 14px rgba(11, 42, 91, 0.3);\n    animation: mh-bounceLeft 2s ease-in-out 1s infinite;\n}\n\n@keyframes mh-bounceLeft {\n\n    0%,\n    100% {\n        transform: translateX(0);\n    }\n\n    50% {\n        transform: translateX(-8px);\n    }\n}\n\n@keyframes mh-fadeInUp {\n    from {\n        opacity: 0;\n        transform: translateY(16px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n@keyframes mh-fadeIn {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n/* ── Chart Header ── */\n.mh-chart-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 12px;\n    gap: 12px;\n    flex-wrap: wrap;\n    flex-shrink: 0;\n}\n\n.mh-chart-title {\n    font-size: 16px;\n    font-weight: 700;\n    color: var(--third-color);\n    margin: 0;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    position: relative;\n    left: 5%;\n\n}\n\n.mh-chart-controls {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    background: #f8fafc;\n    padding: 4px 6px;\n    border-radius: 12px;\n    border: 1px solid #e2e8f0;\n    flex-shrink: 0;\n    position: relative;\n    right: 5%;\n}\n\n/* ── Y-Axis Toggle ── */\n.mh-yaxis-toggle {\n    display: flex;\n    align-items: center;\n    gap: 0;\n    background: #fff;\n    border-radius: 8px;\n    border: 1px solid #e2e8f0;\n    padding: 2px;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n}\n\n.mh-toggle-label {\n    font-size: 11px;\n    font-weight: 600;\n    color: #64748b;\n    padding: 0 8px;\n    white-space: nowrap;\n}\n\n.mh-toggle-btn {\n    padding: 4px 10px;\n    border-radius: 6px;\n    border: none;\n    background: transparent;\n    font-size: 11px;\n    font-weight: 600;\n    color: #64748b;\n    cursor: pointer;\n    transition: all 0.15s ease;\n    white-space: nowrap;\n}\n\n.mh-toggle-btn:hover {\n    background: #f1f5f9;\n}\n\n.mh-toggle-active {\n    background: #f1f5f9 !important;\n    color: #0f172a !important;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);\n}\n\n.mh-divider {\n    width: 1px;\n    height: 20px;\n    background: #cbd5e1;\n    flex-shrink: 0;\n}\n\n/* ── Time Badge ── */\n.mh-time-badge {\n    padding: 4px 10px;\n    background: #fff;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    font-size: 12px;\n    font-weight: 600;\n    color: #475569;\n    white-space: nowrap;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n}\n\n/* ── Refresh / Reset Button ── */\n.mh-refresh-btn {\n    width: 30px;\n    height: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #fff;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    color: #64748b;\n    font-size: 14px;\n    cursor: pointer;\n    transition: all 0.15s ease;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n}\n\n.mh-refresh-btn:hover {\n    color: #0B2A5B;\n    background: rgba(11, 42, 91, 0.06);\n    border-color: rgba(11, 42, 91, 0.2);\n}\n\n/* ── Chart Area ── */\n.mh-chart-area {\n    flex: 1;\n    min-height: 0;\n    position: relative;\n    border: 1px solid #f1f5f9;\n    border-radius: 14px;\n    background: rgba(248, 250, 252, 0.4);\n    padding: 12px;\n    overflow: hidden;\n}\n\n.mh-chart-area canvas {\n    width: 100% !important;\n    height: 100% !important;\n}\n\n/* ── Chart Hint ── */\n.mh-chart-hint {\n    position: absolute;\n    top: 8px;\n    right: 10px;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    font-size: 10px;\n    color: #94a3b8;\n    background: rgba(255, 255, 255, 0.85);\n    padding: 3px 8px;\n    border-radius: 6px;\n    border: 1px solid #e2e8f0;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n    z-index: 10;\n    pointer-events: none;\n    backdrop-filter: blur(4px);\n}\n\n/* ── Loading & No Results ── */\n.mh-loading {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n}\n\n.mh-no-results {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    color: #94a3b8;\n    font-size: 14px;\n}\n\n/* ── Keep old classes for compatibility ── */\n.cont-graphic-historic {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
